import { paymentShell } from "./ui";

export function renderHome(root: HTMLElement): void {
  const demoId = (import.meta.env.VITE_DEMO_OFFER_ID || "").trim();
  const origin = (import.meta.env.VITE_PUBLIC_APP_URL || window.location.origin).replace(/\/$/, "");
  root.innerHTML = paymentShell({
    title: "Flowgate Recurring",
    subtitle: "Crypto subscriptions for any website",
    body: `
      <p class="home-lede">Create a Recurring POS in the merchant dashboard. The customer approves a capped ERC-20 allowance once. We create a Flowgate invoice on a timer and pull the tokens ourselves.</p>
      <p class="hint" style="text-align:left;margin-top:20px">Embed on your checkout</p>
      <code class="code">&lt;script src="${origin}/widget.js"&gt;&lt;/script&gt;
&lt;button id="subscribe"&gt;Subscribe&lt;/button&gt;
&lt;script&gt;
  FlowgateRecurring.mount('#subscribe', { id: 'storefront-uuid', planId: 'plan-uuid', reference: 'user-42' });
&lt;/script&gt;</code>
      ${
        demoId
          ? `<div class="picker" style="margin-top:16px"><a class="pick" href="/subscribe?id=${encodeURIComponent(demoId)}" style="text-decoration:none"><span class="pick-text"><strong>Try demo subscribe</strong></span></a></div>`
          : `<p class="hint">Create a Recurring POS, then open /s/your-path</p>`
      }
    `,
  });
}
